import PropTypes from "prop-types"
import React, { useCallback, useEffect, useRef } from "react"
import { useSelector } from "react-redux"

// //Import Scrollbar
import SimpleBar from "simplebar-react"

// MetisMenu
import MetisMenu from "metismenujs"
import withRouter from "components/Common/withRouter"
import { Link } from "react-router-dom"

//i18n
import { withTranslation } from "react-i18next"

import { selectCurrentUser } from "../../store/redux/api/auth/authSlice"
import { getUserGroups, isHubAdmin, isProviderStaff, isOrgAdmin } from "../../utils/roleUtils"

const SidebarContent = props => {
  const ref = useRef()
  const activateParentDropdown = useCallback(item => {
    item.classList.add("active")
    const parent = item.parentElement
    const parent2El = parent.childNodes[1]

    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show")
    }

    if (parent) {
      parent.classList.add("mm-active")
      const parent2 = parent.parentElement

      if (parent2) {
        parent2.classList.add("mm-show") // ul tag

        const parent3 = parent2.parentElement // li tag

        if (parent3) {
          parent3.classList.add("mm-active") // li
          parent3.childNodes[0].classList.add("mm-active") //a
          const parent4 = parent3.parentElement // ul
          if (parent4) {
            parent4.classList.add("mm-show") // ul
            const parent5 = parent4.parentElement
            if (parent5) {
              parent5.classList.add("mm-show") // li
              parent5.childNodes[0].classList.add("mm-active") // a tag
            }
          }
        }
      }
      scrollElement(item)
      return false
    }
    scrollElement(item)
    return false
  }, [])

  const removeActivation = items => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i]
      const parent = items[i].parentElement

      if (item && item.classList.contains("active")) {
        item.classList.remove("active")
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show")
        }

        parent.classList.remove("mm-active")
        const parent2 = parent.parentElement

        if (parent2) {
          parent2.classList.remove("mm-show")

          const parent3 = parent2.parentElement
          if (parent3) {
            parent3.classList.remove("mm-active") // li
            parent3.childNodes[0].classList.remove("mm-active")

            const parent4 = parent3.parentElement // ul
            if (parent4) {
              parent4.classList.remove("mm-show") // ul
              const parent5 = parent4.parentElement
              if (parent5) {
                parent5.classList.remove("mm-show") // li
                parent5.childNodes[0].classList.remove("mm-active") // a tag
              }
            }
          }
        }
      }
    }
  }

  const activeMenu = useCallback(() => {
    const pathName = props.router.location.pathname
    let matchingMenuItem = null
    const ul = document.getElementById("side-menu")
    const items = ul.getElementsByTagName("a")
    removeActivation(items)

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i]
        break
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem)
    }
  }, [props.router.location.pathname, activateParentDropdown])

  useEffect(() => {
    ref.current.recalculate()
  }, [])

  useEffect(() => {
    new MetisMenu("#side-menu")
  }, [])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" })
    activeMenu()
  }, [activeMenu])

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300
      }
    }
  }

  // Права доступа текущего пользователя (роли EyeHub из Keycloak).
  const user = useSelector(selectCurrentUser)
  const userGroups = getUserGroups(user)
  // Enrollment / Federation — provider-ops (hub-admin) или администратор организации.
  const canViewEnrollment = isHubAdmin(userGroups) || isOrgAdmin(userGroups)
  const canViewFederation = isHubAdmin(userGroups) || isOrgAdmin(userGroups)
  // Лицензии — сторона провайдера (hub-admin / hub-support-engineer).
  const canViewLicenses = isProviderStaff(userGroups)
  // Коннекторы (fleet-обзор) — сторона провайдера.
  const canViewConnectors = isProviderStaff(userGroups)
  // Флот (снимки инсталляций) и диагностические бандлы — hub-admin + поддержка.
  const canViewFleet = isProviderStaff(userGroups)
  const canViewDiagnosticBundles = isProviderStaff(userGroups)
  // Ключи подписи лицензий — только администратор хаба.
  const canViewSigningKeys = isHubAdmin(userGroups)
  // Провижининг (срез 3) — только hub-admin: backend AdminProvisioningOrderViewSet
  // закрыт под IsHubAdmin, а retry запускает сагу с внешними эффектами.
  const canViewProvisioning = isHubAdmin(userGroups)
  // «Мои лицензии» — витрина потребления и переключатель перерасхода организации.
  // Пункт видит org-admin; hub-admin тоже проходит IsOrgAdmin, но своих организаций
  // у него обычно нет — витрина будет пустой, и в меню его звать незачем.
  const canViewMyLicenses = isOrgAdmin(userGroups)

  return (
    <React.Fragment>
      <SimpleBar className="sidebar-simplebar" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("sidebar.home")} </li>

            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="mdi mdi-view-dashboard"></i>
                <span>{props.t("sidebar.dashboard")}</span>
              </Link>
            </li>

            <li>
              <Link to="/my-sites" className="waves-effect">
                <i className="mdi mdi-office-building-marker-outline"></i>
                <span>{props.t("sidebar.mySites")}</span>
              </Link>
            </li>

            <li>
              <Link to="/organizations" className="waves-effect">
                <i className="mdi mdi-domain"></i>
                <span>{props.t("sidebar.organizations")}</span>
              </Link>
            </li>

            {canViewEnrollment && (
              <li>
                <Link to="/enrollment" className="waves-effect">
                  <i className="mdi mdi-lan-connect"></i>
                  <span>{props.t("sidebar.enrollment")}</span>
                </Link>
              </li>
            )}

            {canViewConnectors && (
              <li>
                <Link to="/connectors" className="waves-effect">
                  <i className="mdi mdi-connection"></i>
                  <span>{props.t("sidebar.connectors")}</span>
                </Link>
              </li>
            )}

            {canViewFleet && (
              <li>
                <Link to="/fleet" className="waves-effect">
                  <i className="mdi mdi-server-network"></i>
                  <span>{props.t("sidebar.fleet")}</span>
                </Link>
              </li>
            )}

            {canViewLicenses && (
              <li>
                <Link to="/licenses" className="waves-effect">
                  <i className="mdi mdi-certificate"></i>
                  <span>{props.t("sidebar.licenses")}</span>
                </Link>
              </li>
            )}

            {canViewMyLicenses && (
              <li>
                <Link to="/my-licenses" className="waves-effect">
                  <i className="mdi mdi-gauge"></i>
                  {/* Строки среза 3 живут в своём namespace, а не в common:
                      так пункт меню и экран правятся одним файлом локали. */}
                  <span>{props.t("provisioning:myLicenses.title")}</span>
                </Link>
              </li>
            )}

            {canViewProvisioning && (
              <li>
                <Link to="/provisioning" className="waves-effect">
                  <i className="mdi mdi-cog-transfer-outline"></i>
                  <span>{props.t("provisioning:title")}</span>
                </Link>
              </li>
            )}

            {canViewSigningKeys && (
              <li>
                <Link to="/signing-keys" className="waves-effect">
                  <i className="mdi mdi-key-chain-variant"></i>
                  <span>{props.t("sidebar.signingKeys")}</span>
                </Link>
              </li>
            )}

            {canViewSigningKeys && (
              <li>
                <Link to="/release-trust" className="waves-effect">
                  <i className="mdi mdi-shield-key-outline"></i>
                  <span>{props.t("sidebar.releaseTrust")}</span>
                </Link>
              </li>
            )}

            {canViewFederation && (
              <li>
                <Link to="/federation" className="waves-effect">
                  <i className="mdi mdi-share-variant"></i>
                  <span>{props.t("sidebar.federation")}</span>
                </Link>
              </li>
            )}

            <li>
              <Link to="/support" className="waves-effect">
                <i className="mdi mdi-lifebuoy"></i>
                <span>{props.t("sidebar.support")}</span>
              </Link>
            </li>

            {canViewDiagnosticBundles && (
              <li>
                <Link to="/diagnostic-bundles" className="waves-effect">
                  <i className="mdi mdi-package-variant-closed"></i>
                  <span>{props.t("sidebar.diagnosticBundles")}</span>
                </Link>
              </li>
            )}

            <li>
              <Link to="/maintenance" className="waves-effect">
                <i className="mdi mdi-calendar-clock"></i>
                <span>{props.t("sidebar.maintenance")}</span>
              </Link>
            </li>

          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  )
}

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
}

export default withRouter(withTranslation()(SidebarContent))
